'use strict';

const events = {
  REPORT_TRACE: {
    src: 72,
    eventId: 100,
    endpoint: 'trace',
    params: {
      appName: 'appName',
      pageId: 'pageId',
      pageUrl: 'pageUrl',
      timeFromStartMs: 'timeFromStartMs',
      actionName: 'actionName',
      actionDurationMs: 'actionDurationMs',
      timestampMs: 'timestampMs',
      tracePosition: 'tracePosition',
      msid: 'msid'
    }
  },
  PLATFORM_RENDER_STEP: {
    src: 72,
    eventId: 300,
    endpoint: 'performance',
    params: {
      actionDurationMs: 'actionDurationMs',
      actionName: 'actionName',
      appId: 'appId',
      msid: 'msid',
      pageId: 'pageId',
      pageUrl: 'pageUrl',
      pn: 'pn',
      isServerSide: 'isServerSide',
      postSSR: 'postSSR',
      requestId: 'requestId',
      ts: 'ts',
      tsn: 'tsn',
      widgetArray: 'widgetArray',
      widgetId: 'widgetId',
      vsi: 'vsi'
    }
  },
  WORKER_TERMINATED: {
    src: 79,
    eventId: 102,
    endpoint: 'platform-viewer',
    params: {
      worker_id: 'worker_id',
      ts: 'ts'
    }
  },
  APP_PAGE_READY: {
    src: 79,
    eventId: 110,
    endpoint: 'platform-viewer',
    params: {
      app_id: 'app_id',
      worker_id: 'worker_id',
      time_spent: 'time_spent',
      ts: 'ts'
    }
  },
  ALL_APPS_PAGE_READY: {
    src: 79,
    eventId: 109,
    endpoint: 'platform-viewer',
    params: {
      worker_id: 'worker_id',
      time_spent: 'time_spent',
      ts: 'ts'
    }
  },
  BOOTSTRAP_DONE: {
    src: 79,
    eventId: 132,
    endpoint: 'platform-viewer',
    params: {
      ts: 'ts'
    }
  },
  USER_CODE_LOADED: {
    src: 79,
    eventId: 133,
    endpoint: 'platform-viewer',
    params: {
      worker_id: 'worker_id',
      ts: 'ts'
    }
  },
  WIDGET_READY: {
    src: 79,
    eventId: 164,
    params: {
      worker_id: 'worker_id',
      ts: 'ts'
    }
  }
};

module.exports = events;
